// extracted by mini-css-extract-plugin
export default {"paginator":"ItemList_paginator__1ScQ1","tableActions":"ItemList_tableActions__rTpL0"};